









































































































































































import Vue from "vue";

// Components
import ConnectivityStatusChip from "../../Components/chips/ConnectivityStatusChip.vue";
import GlobalStatusInstallationChip from "../../Components/chips/GlobalStatusInstallationChip.vue";

// Model
import { getInstallationConnectivityStatusIconColor, getInstallationStatusIconColor } from "@/utility/Constants";
import { installationStatusDescription, installationStatusEnumLabel } from "@/model/data/status/InstallationStatusEnum";
import { GlobalStatusEnum } from "@/model/data/status/GlobalStatusEnum";
import { connectivityStatusDescription, ConnectivityStatusEnum, connectivityStatusEnumLabel } from "@/model/data/status/ConnectivityStatusEnum";

export default Vue.extend({
    components: { ConnectivityStatusChip, GlobalStatusInstallationChip },
    props: {
        filteredTotalsByStatus: {
            required: true,
        },
        totalsByStatus: {
            required: true,
        },
        filteredTotalsByConnectivityStatus: {
            required: true,
        },
        totalsByConnectivityStatus: {
            required: true,
        },
        loading: {
            required: true,
            type: Boolean,
        },
        reqData: {
            required: true,
        },
    },
    data() {
        return {
            firstTime: true,
            minimized: false,
        };
    },
    watch: {
        loading(newValue) {
            if (!newValue) this.firstTime = false;
        },
    },
    methods: {
        getInstallationStatusIconColor,
        getInstallationConnectivityStatusIconColor,
        installationStatusEnumLabel,
        connectivityStatusEnumLabel,
        installationStatusDescription,
        connectivityStatusDescription,

        toggleFilter(globalStatus: GlobalStatusEnum) {
            let newReqData = Object.assign({}, this.reqData);
            newReqData.offset = 0;

            if (this.reqData.globalStatusFilter != null) {
                if (this.reqData.globalStatusFilter.includes(globalStatus)) {
                    newReqData.globalStatusFilter = this.reqData.globalStatusFilter.filter((v) => v != globalStatus);
                    if (newReqData.globalStatusFilter.length == 0) newReqData.globalStatusFilter = null;
                } else newReqData.globalStatusFilter.push(globalStatus);
            } else {
                newReqData.globalStatusFilter = [];
                newReqData.globalStatusFilter.push(globalStatus);
            }

            console.debug("Send request because filters changed");
            this.$emit("send-request", newReqData);
        },
        toggleFilterConnectivity(connectivityStatus: ConnectivityStatusEnum) {
            let newReqData = Object.assign({}, this.reqData);
            newReqData.offset = 0;

            if (this.reqData.connectivityStatusFilter != null) {
                if (this.reqData.connectivityStatusFilter.includes(connectivityStatus)) {
                    newReqData.connectivityStatusFilter = this.reqData.connectivityStatusFilter.filter((v) => v != connectivityStatus);
                    if (newReqData.connectivityStatusFilter.length == 0) newReqData.connectivityStatusFilter = null;
                } else newReqData.connectivityStatusFilter.push(connectivityStatus);
            } else {
                newReqData.connectivityStatusFilter = [];
                newReqData.connectivityStatusFilter.push(connectivityStatus);
            }

            console.debug("Send request because filters changed");
            this.$emit("send-request", newReqData);
        },
        getFilteredTotal(installationStatus) {
            return this.filteredTotalsByStatus.filter((i) => i.installationStatus == installationStatus)[0].total;
        },
        getFilteredConnectivityTotal(installationStatus) {
            return this.filteredTotalsByConnectivityStatus.filter((i) => i.installationStatus == installationStatus)[0].total;
        },
    },
});
